<template>
  <v-dialog
      content-class="safetyStWrapper"
      :value="true"
      fullscreen
      hide-overlay
      persistent
  >
    <div class="safetySt">
      <div class="safetySt_header">
        <span>Create statements</span>
        <button type="button" @click="closeDialog">
          <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
        </button>
      </div>
      <div v-if="dispatcherRate" class="safetySt_top">
        <div class="safetySt_top-fl">
          <field
              margin="0 0 0 10px"
              label="Select month"
              placeholder="Select date"
              width="160px"
              item-text="name"
              item-value="currentDate"
              @updateSelect="onSelect"
              :autocompleteValue="currentDate"
              :items="month"
              :isClearable="false"
              is-select
          ></field>
        </div>
        <div class="safetySt_top-fl">
          <template v-for="(item, idx) in dispatcherRate">
            <field
                :key="item.id"
                :label="`${idx + 1}st shift rate`"
                :margin="`0 ${idx === 2 ? '20px' : '0'} 0 10px`"
                width="150px"
                type="number"
                :idx="idx"
                :setInputValue="item.amount"
                @updateInput="onInput"
            ></field>
          </template>
          <button @click="onRate" type="button" class="mainBtn">
            <span class="btnText">Set rate</span>
          </button>
        </div>
      </div>
      <main-table
          v-if="safetyStatementsCreateList"
          flag="safety-statement"
          :headers="getHeader"
          :listItems="safetyStatementsCreateList"
          :filtersList="safetyStatementsCreateFilter"
          :uniqId="uniqId"
          :checkAll="checkAll"
          :indeterminate="indeterminate"
          @updateClickButton="onClickButton"
          @updateSearch="onFilter"
          @updateRefreshFilters="onFilter"
          @updateChangeSort="onFilter"
          @updateCheckOrder="onCheckOrder"
          @updateCheckOrders="onCheckOrders"
          @updateExport="onExport"
          :is-create="false"
          :is-export="false"
      ></main-table>
      <button-groups
          margin="30px 0 0 0"
          :is-btn-safe="!selected.length"
          @updateBtnClose="closeDialog"
          @updateSave="onSave"
      ></button-groups>
    </div>
  </v-dialog>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
// constants
import { safetyStatementsCreateHeader } from "@/pages/Accounting/SafetyStatements/constants";

export default {
	name: "SafetyStatementsCreate",
	components: { ButtonGroups },
	computed: {
		...mapGetters([
			"safetyStatementsItem",
			"safetyStatementsCreateFilter",
			"safetyStatementsCreateList",
		]),
		getHeader() {
			return safetyStatementsCreateHeader;
		},
	},
	data: () => ({
		currentDate: null,
		month: [],
		uniqId: null,
		checkAll: false,
		rows: null,
		dispatcherRate: null,
		filter: {},
		selected: [],
		indeterminate: false,
	}),
	methods: {
		...mapActions([
			"onSafetyStatementsCreate",
			"onSafetyStatementsCreateFilter",
			"getSafetyStatementsExport",
			"onSafetyStatementsCreateView",
			"onSafetyStatementsSave",
			"onSafetyStatementsRate",
			"setAlert"
		]),

		async onSave() {
			await this.onSafetyStatementsSave({ rows: this.selected, date: this.currentDate.date });
			this.closeDialog();
		},

		async onExport(value) {
			await this.getSafetyStatementsExport({ value });
		},
		async onFilter(info) {
			this.indeterminate = false;
			this.checkAll = false;
			this.selected = [];
			await this.onSafetyStatementsCreateFilter({ date: this.currentDate.date, ...info.filterModList });
		},

		async onClickButton({ item }) {
			await this.onSafetyStatementsCreateView(item);
			this.$emit("updateView");
		},
		onCheckOrder(orderId) {
			const idx = this.selected.findIndex(({ user_id }) => user_id === orderId);
			const item = this.safetyStatementsCreateList.find(({ user_id }) => user_id === orderId);
			if (idx === -1) {
				this.selected.push(item);
			} else {
				this.selected.splice(idx, 1);
			}

			if (!this.selected.length) {
				this.indeterminate = false;
				this.checkAll = false;
			}

			if (this.selected.length && this.selected.length !== this.safetyStatementsCreateList.length) {
				this.indeterminate = true;
			}

			if (this.selected.length === this.safetyStatementsCreateList.length) {
				this.indeterminate = false;
				this.checkAll = true;
			}
		},
		onCheckOrders(value) {
			if (value) {
				this.selected = this.safetyStatementsCreateList.map((body) => body);
			} else {
				this.selected = [];
				this.indeterminate = false;
			}

			this.checkAll = value;
			this.safetyStatementsCreateList.forEach((item) => (item.isCheck = value));
		},
		closeDialog() {
			this.$emit("updateClose");
		},
		async onSelect({ value }) {
			this.currentDate = value;
			await this.onSafetyStatementsCreateFilter({ date: this.currentDate.date });
			this.selected = [];
		},
		onInput({ value, idx }) {
			this.dispatcherRate[idx].amount = +value;
		},
		async onRate() {
			await this.onSafetyStatementsRate({ dispatcher_rate: this.dispatcherRate });
		}
	},
	async mounted() {
		await this.onSafetyStatementsCreate({});

		if (this.safetyStatementsItem) {
			const { month, dispatcher_rate } = this.safetyStatementsItem;
			if (dispatcher_rate) this.dispatcherRate = dispatcher_rate;
			if (month) {
				this.month = month.reverse();
				this.currentDate = month[1];
			}
		}
	},
};
</script>

<style scoped lang="scss">
@import "safetyStatementsCreate";
</style>
